/* eslint-disable */
import React, { useState, RefObject } from "react";
import SwiperCore from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
// import "swiper/components/navigation/navigation.scss";
import styles from "./AddTimeStampSlideGroup.module.css";
import "../../common/components/slide/navigationButton.css";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { IconButton } from "@material-ui/core";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import PuiTypography from "../elements/PuiTypography";
import { VideoSlide } from "../../common/video/models/Video";
import { Document, Page, pdfjs } from "react-pdf";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../root/RootReducer";
import PuiMessage from "./PuiMessage";
import { UploadVideoSlide } from "../../common/video/VideoActions";
import { stringifyVideoTimeWithColons } from "../../common/video/util/videoTimeStrings";

SwiperCore.use([Navigation]);



export interface AddTimeStampSlideGroupProps {
  slideList: VideoSlide[];
  SetSlideList: (slideList: VideoSlide[]) => void;
  videoRef: RefObject<HTMLVideoElement> | null;
  setIsSaved: (isSaved: boolean) => void;
  videoId: number;
}

export default function AddTimeStampSlideGroup({
  slideList,
  SetSlideList,
  videoRef,
  setIsSaved,
  videoId,
}: AddTimeStampSlideGroupProps) {
  const { videoPdf } = useSelector((state: AppState) => ({
    videoPdf: state.video.videoPdf,
  }));

  const dispatch = useDispatch();
  const [numPages, setNumPages] = useState<number>(1);

  // スライド読み込み時
  function onDocumentLoadSuccess({ numPages }) {
    console.log("onDocumentLoadSuccess");
    console.log(numPages);
    setNumPages(numPages);
    // 時間未割り当ての場合、時間を初期設定する
    if (videoPdf && videoPdf.videoSlides) {
      if (numPages !== slideList.length && slideList.length === 1) {
        Array.from(new Array(numPages), function (row, index) {
          if (index === 0) {
            slideList[0] = {
              slideId: index + 1,
              startMillis: -1,
              videoId: videoId,
            };
          } else {
            slideList.push({
              slideId: index + 1,
              startMillis: -1,
              videoId: videoId,
            });
          }
          return null;
        });
        dispatch(
          UploadVideoSlide({
            videoId: videoId,
            file: null,
            slideName: videoPdf.slideName,
            isPublic: videoPdf.isPublic,
            videoSlides: slideList,
          })
        );
      }
    }
  }

  // スライドに時間を設定する
  const AddTimeStamp = (index: number) => {
    console.log("AddTimeStamp start");
    if (videoRef) {
      if (videoRef.current) {
        const time = Math.floor(videoRef.current.currentTime * 1000);
        const temp: VideoSlide[] = JSON.parse(JSON.stringify(slideList));
        temp[index].startMillis = Math.floor(
          videoRef.current.currentTime * 1000
        );

        if (CheckSetTimes(temp) === true) {
          ChangeTimeStamp(index, time);
        } else {
          ChangeErrorInputTimeFlag(true);
        }
      }
    }
    setIsSaved(false);
  };

  // スライドの割り当て時間を削除する
  const DeleteTimeStamp = (slideNum: number) => {
    console.log("DeleteTimeStamp start");
    ChangeTimeStamp(slideNum, -1);
    setIsSaved(false);
  };

  // 時間の変更関数
  const ChangeTimeStamp = (index: number, time: number) => {
    console.log("ChangeTimeStamp start ");
    const temp = [...slideList];
    temp[index].startMillis = time;
    SetSlideList(temp);
    setIsSaved(false);
  };

  // スライドの時間設定の順番に間違いがないか確認
  const [isErrorInputTime, ChangeErrorInputTimeFlag] = useState(false);
  const CloseErrorInputTime = () => {
    ChangeErrorInputTimeFlag(false);
  };

  const CheckSetTimes = (tempList: VideoSlide[]) => {
    console.log("CheckSetTimes start");
    const millisList: number[] = [];
    tempList.map(function (row, index) {
      if (index === 0 || row.startMillis === -1) {
        millisList.push(row.startMillis);
      } else if (row.startMillis === 0) {
        return null;
      } else if (millisList.filter((v) => v > row.startMillis).length === 0) {
        millisList.push(row.startMillis);
      } else {
        return null;
      }
      return null;
    });
    if (millisList.length !== tempList.length) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <>
      {slideList && videoPdf && (
        <Document
          file={videoPdf.slideUrl}
          onLoadSuccess={onDocumentLoadSuccess}
          options={{
            cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
            cMapPacked: true,
          }}
        >
          {numPages === slideList.length && (
            <div>
              <Swiper
                slidesPerView={3}
                loop={false}
                navigation={{
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                }}
                initialSlide={0}
                centeredSlides={false}
                slideToClickedSlide={true}
                style={{ position: "relative" }}
              >
                {Array.from(new Array(numPages), (row, index) => (
                  <SwiperSlide
                    id={`page_${index + 1}`}
                    key={`recordSlide-${index}`}
                    className={styles.slideImg}
                  >
                    <Page
                      key={`page_${index + 1}`}
                      pageNumber={index + 1}
                      className={styles.page}
                    />
                    <div
                      id={String(index + 1)}
                      className={styles.slideTitle}
                    >{`Page ${index + 1}`}</div>
                    {slideList[index].startMillis !== -1 ? (
                      <div className={styles.deleteButton}>
                        <IconButton
                          onClick={() => DeleteTimeStamp(index)}
                          className={styles.icon}
                        >
                          <HighlightOffIcon
                            style={{ color: "var(--gray-85)" }}
                          />
                        </IconButton>
                        <PuiTypography>
                          {stringifyVideoTimeWithColons(
                            slideList[index].startMillis,
                            true
                          )}
                        </PuiTypography>
                      </div>
                    ) : (
                      <div className={styles.addButton}>
                        <IconButton
                          onClick={() => AddTimeStamp(index)}
                          className={styles.icon}
                        >
                          <AddCircleOutlineIcon
                            style={{ color: "var(--red)" }}
                          />
                        </IconButton>
                      </div>
                    )}
                  </SwiperSlide>
                ))}
                <div
                  style={{ height: "100%", top: "7%" }}
                  className="swiper-button-next swiper-button-white"
                ></div>
                <div
                  style={{ height: "100%", top: "7%" }}
                  className="swiper-button-prev swiper-button-white"
                ></div>
              </Swiper>
            </div>
          )}
        </Document>
      )}

      <PuiMessage
        open={isErrorInputTime}
        type="error"
        title="時間はSlideの並び順に合わせて設定してください"
        duration={5000}
        onClose={CloseErrorInputTime}
      />
    </>
  );
}
